module.exports = "/images/buy-before-sell.png?3bc426f70e53e2e0cc1468ca608d3bd6";